import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { QUERY_KEYS } from "@/components/Brand/constants/queryKeys";
import { AdditionalCouponDialog, AdditionalCouponDrawer } from "@/components/Coupons/AdditionalCouponContents";
import useLegacyCouponReceive from "@/components/Package/PurchaseSection/legacy/useLegacyCouponReceive";
import { usePurchaseStore } from "@/components/Package/PurchaseSection/purchaseStore";
import { HandoutAllowanceSection } from "@/components/Product/Handout/HandoutAllowanceSection";
import { ProductRating } from "@/components/Reviews";
import { OnlySolvookTag } from "@/components/Tags";
import Icon from "@/components/icon/Icon";
import { ArrowRight, Check_Thin, Sizes } from "@/components/icon/IconList";
import CheckLoginDialog from "@/components/modal/CheckLoginDialog";
import { useAuthStore } from "@/lib/auth/AuthStore";
import { mixpanelEvent } from "@/lib/mixpanels/mixpanel";
import useWindowDimensions from "@/lib/web-ui/useWindowDimensions";
import { IconV2 } from "@bookips/sds";
import { Button } from "@bookips/solvook-ui-library";
import { Box, Divider, Stack, Typography, styled, useTheme } from "@mui/material";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import dayjs from "dayjs";
import { motion } from "framer-motion";
import Image from "next/image";
import { useRouter } from "next/router";
import { useCallback, useState } from "react";
import { isBooksProduct } from "src/api/booksProducts";
import { getBrand, postSubscribeBrand } from "src/api/brand";
import { getProductHandoutType, SourceTypeWithString } from "src/api/product";
import useHandoutProductStore from "src/store/relatedProduct";
import HandoutPriceSection from "./HandoutPriceSection";
const DEFAULT_BADGE_TEXT = "쏠북패스 Only";
export const HandoutCoreSection = (param)=>{
    let { product , productType , authorLabName , publisherName , isFreepass , badgeText , freeTrialData  } = param;
    const theme = useTheme();
    const router = useRouter();
    const isBooks = isBooksProduct(product);
    const { isMobile  } = useWindowDimensions();
    const { isLoggedIn  } = useAuthStore();
    const [checkModal, setCheckModal] = useState(false);
    const { type , isOriginSellable , originalFileName  } = product;
    const { showCouponModal , setFlags , selectedTab , hasSelectedPass  } = usePurchaseStore((state)=>({
            showCouponModal: state.showCouponModal,
            setFlags: state.setFlags,
            selectedTab: state.selectedTab,
            hasSelectedPass: state.selectedPass !== null && !state.selectedPass.isDisabled
        }));
    const { rating  } = useHandoutProductStore((state)=>({
            rating: state.rating
        }));
    const { handoutCoupons , filteredHasCoupon  } = useLegacyCouponReceive({
        id: product.id,
        price: product.price
    });
    const { data: brandInfo  } = useQuery(QUERY_KEYS.BRAND(authorLabName), ()=>getBrand(authorLabName), {
        enabled: !!authorLabName
    });
    const queryClient = useQueryClient();
    const postSubscribeBrandMutation = useMutation(postSubscribeBrand, {
        onSuccess: ()=>{
            queryClient.invalidateQueries(QUERY_KEYS.BRAND(authorLabName));
        }
    });
    const checkLogin = useCallback(()=>{
        if (!isLoggedIn) setFlags({
            showSignInModal: true
        });
        else setFlags({
            showCouponModal: !showCouponModal
        });
    }, [
        isLoggedIn
    ]);
    const handleSubscribeClick = useCallback(async ()=>{
        //mx-269
        mixpanelEvent("Subscribe Button Clicked", {
            Position: "Product Detail Page",
            "Button Name": "".concat((brandInfo === null || brandInfo === void 0 ? void 0 : brandInfo.isSubscribed) ? "소식 받는 중" : "소식받기"),
            "Brand Name": brandInfo === null || brandInfo === void 0 ? void 0 : brandInfo.title
        });
        if (!isLoggedIn) {
            setFlags({
                showSignInModal: true
            });
            return;
        }
        if (!(brandInfo === null || brandInfo === void 0 ? void 0 : brandInfo.isSubscribed)) {
            try {
                postSubscribeBrandMutation.mutateAsync({
                    name: authorLabName,
                    isSubscribed: !(brandInfo === null || brandInfo === void 0 ? void 0 : brandInfo.isSubscribed)
                });
            } catch (error) {
                ;
            }
        }
    }, [
        isLoggedIn
    ]);
    var _handoutCoupons_coupons, _handoutCoupons_coupons1;
    return /*#__PURE__*/ _jsxs(BoxArticle, {
        children: [
            /*#__PURE__*/ _jsxs(Box, {
                display: "flex",
                flexDirection: "column",
                gap: "20px",
                children: [
                    /*#__PURE__*/ _jsxs(Box, {
                        sx: {
                            display: "flex",
                            flexDirection: "column",
                            gap: theme.spacing(1)
                        },
                        children: [
                            /*#__PURE__*/ _jsxs(Stack, {
                                direction: "row",
                                spacing: 1.5,
                                alignItems: "center",
                                children: [
                                    isFreepass && /*#__PURE__*/ _jsx(OnlySolvookTag, {
                                        sx: {
                                            position: "static"
                                        },
                                        children: badgeText !== null && badgeText !== void 0 ? badgeText : DEFAULT_BADGE_TEXT
                                    }),
                                    /*#__PURE__*/ _jsxs(Typography, {
                                        variant: "body2",
                                        sx: {
                                            color: "primary.main",
                                            "& span": {
                                                color: "grey.400",
                                                ml: 1.5
                                            }
                                        },
                                        children: [
                                            SourceTypeWithString[productType],
                                            " ",
                                            isBooks ? /*#__PURE__*/ _jsx("span", {
                                                children: dayjs(product.publishedAt).format("YYYY년 개정판")
                                            }) : (productType === "textbook" || productType === "workbook") && /*#__PURE__*/ _jsx("span", {
                                                children: product.published_at && dayjs(product.published_at).format("YYYY년 출간")
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsx(Typography, {
                                variant: isMobile ? "h6" : "h4",
                                children: product.title
                            }),
                            /*#__PURE__*/ _jsx(Box, {
                                display: "flex",
                                gap: "6px",
                                children: rating ? /*#__PURE__*/ _jsxs(_Fragment, {
                                    children: [
                                        /*#__PURE__*/ _jsx(ProductRating, {
                                            precision: 0.1,
                                            value: rating,
                                            readOnly: true,
                                            size: Sizes.xmedium
                                        }),
                                        /*#__PURE__*/ _jsx("p", {
                                            children: Number.isInteger(rating) ? "".concat(rating, ".0") : rating
                                        })
                                    ]
                                }) : null
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs(BrandInfoBox, {
                        children: [
                            /*#__PURE__*/ _jsx(Box, {
                                sx: {
                                    display: "flex",
                                    gap: "12px"
                                },
                                children: authorLabName ? /*#__PURE__*/ _jsxs(Button, {
                                    variant: "text",
                                    href: authorLabName ? "/@".concat(authorLabName) : "",
                                    sx: {
                                        display: "flex",
                                        gap: "12px",
                                        padding: "0px",
                                        ":hover": {
                                            background: "transparent",
                                            "p:last-child": {
                                                textDecoration: "underline"
                                            }
                                        }
                                    },
                                    children: [
                                        /*#__PURE__*/ _jsx(Box, {
                                            width: 40,
                                            height: 40,
                                            position: "relative",
                                            borderRadius: "50%",
                                            overflow: "hidden",
                                            border: "1px solid ".concat(theme.palette.opacity.gray300["20%"]),
                                            children: /*#__PURE__*/ _jsx(Image, {
                                                src: brandInfo === null || brandInfo === void 0 ? void 0 : brandInfo.profileImageUrl,
                                                alt: brandInfo === null || brandInfo === void 0 ? void 0 : brandInfo.name,
                                                fill: true
                                            })
                                        }),
                                        /*#__PURE__*/ _jsxs(Box, {
                                            display: "flex",
                                            flexDirection: "column",
                                            alignItems: "start",
                                            children: [
                                                /*#__PURE__*/ _jsx(Typography, {
                                                    variant: "subtitle1",
                                                    color: "text.primary",
                                                    children: product.author
                                                }),
                                                /*#__PURE__*/ _jsxs(Typography, {
                                                    variant: "body2",
                                                    color: "text.secondary",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    children: [
                                                        "브랜드 홈",
                                                        /*#__PURE__*/ _jsx(Icon, {
                                                            icon: ArrowRight,
                                                            size: Sizes.xsmall,
                                                            color: theme.palette.text.secondary
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }) : /*#__PURE__*/ _jsx(Typography, {
                                    variant: "subtitle1",
                                    color: "text.primary",
                                    sx: {
                                        ":hover": {
                                            cursor: "text"
                                        }
                                    },
                                    children: product.author
                                })
                            }),
                            authorLabName && ((brandInfo === null || brandInfo === void 0 ? void 0 : brandInfo.isSubscribed) ? /*#__PURE__*/ _jsxs(Typography, {
                                variant: "subtitle2",
                                color: "text.secondary",
                                display: "flex",
                                gap: "4px",
                                padding: "6px 0",
                                alignItems: "center",
                                children: [
                                    /*#__PURE__*/ _jsx(Icon, {
                                        icon: Check_Thin,
                                        size: Sizes.small,
                                        color: theme.palette.text.secondary
                                    }),
                                    "소식 받는 중"
                                ]
                            }) : /*#__PURE__*/ _jsxs(Box, {
                                sx: {
                                    position: "relative"
                                },
                                children: [
                                    /*#__PURE__*/ _jsx(Button, {
                                        variant: "strokePrimary",
                                        size: "small",
                                        sx: {
                                            height: "fit-content",
                                            display: "flex",
                                            gap: "4px"
                                        },
                                        label: /*#__PURE__*/ _jsxs(_Fragment, {
                                            children: [
                                                /*#__PURE__*/ _jsx(IconV2.Home, {
                                                    className: "text-primary-main",
                                                    size: "xs"
                                                }),
                                                "소식받기"
                                            ]
                                        }),
                                        onClick: handleSubscribeClick
                                    }),
                                    /*#__PURE__*/ _jsx(MotionBox, {
                                        initial: {
                                            opacity: 0,
                                            y: -3
                                        },
                                        animate: {
                                            opacity: 1,
                                            y: -9
                                        },
                                        transition: {
                                            delay: 0.3,
                                            duration: 0.4,
                                            ease: "easeOut"
                                        },
                                        sx: {
                                            position: "absolute",
                                            top: "-14px",
                                            left: "12px",
                                            backgroundColor: theme.palette.text.title,
                                            color: theme.palette.blackAndWhite.white,
                                            zIndex: 1,
                                            borderRadius: "4px"
                                        },
                                        children: /*#__PURE__*/ _jsx(TooltipBubble, {
                                            sx: {
                                                whiteSpace: "nowrap",
                                                // 툴팁을 소식받기 버튼 위로 이동
                                                left: "-103px",
                                                backgroundColor: theme.palette.grey[700]
                                            },
                                            children: /*#__PURE__*/ _jsx(Typography, {
                                                variant: "bold12",
                                                sx: {
                                                    display: "block"
                                                },
                                                children: "카톡으로 브랜드 소식을 알려드려요"
                                            })
                                        })
                                    })
                                ]
                            }))
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs(Box, {
                children: [
                    /*#__PURE__*/ _jsx(HandoutPriceSection, {
                        price: {
                            downloadPrice: isBooks ? 0 : product.downloadPrice,
                            viewPrice: product.price
                        },
                        purchaseOptions: isBooks ? null : product.purchaseOptions,
                        handoutCoupons: handoutCoupons,
                        onCouponClick: checkLogin,
                        filteredHasCoupon: filteredHasCoupon,
                        isFreepass: isFreepass,
                        handoutType: isBooks ? undefined : getProductHandoutType(product),
                        originFileInfo: {
                            isOriginSellable,
                            originalFileName
                        },
                        freeTrialData: freeTrialData,
                        productId: product.id,
                        isLoggedIn: isLoggedIn
                    }),
                    isMobile ? /*#__PURE__*/ _jsx(AdditionalCouponDrawer, {
                        anchor: "bottom",
                        open: showCouponModal,
                        handleClose: ()=>setFlags({
                                showCouponModal: false
                            }),
                        handoutCoupons: (_handoutCoupons_coupons = handoutCoupons === null || handoutCoupons === void 0 ? void 0 : handoutCoupons.coupons) !== null && _handoutCoupons_coupons !== void 0 ? _handoutCoupons_coupons : []
                    }) : /*#__PURE__*/ _jsx(AdditionalCouponDialog, {
                        open: showCouponModal,
                        handleClose: ()=>setFlags({
                                showCouponModal: false
                            }),
                        handoutCoupons: (_handoutCoupons_coupons1 = handoutCoupons === null || handoutCoupons === void 0 ? void 0 : handoutCoupons.coupons) !== null && _handoutCoupons_coupons1 !== void 0 ? _handoutCoupons_coupons1 : []
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(Divider, {}),
            !isBooks && /*#__PURE__*/ _jsx(HandoutAllowanceSection, {
                productType: type,
                isBooks: isBooks,
                purchaseOptions: product.purchaseOptions,
                originFileInfo: {
                    isOriginSellable,
                    originalFileName
                }
            }),
            /*#__PURE__*/ _jsx(CheckLoginDialog, {
                open: checkModal,
                onClose: ()=>setCheckModal(false)
            })
        ]
    });
};
const BoxArticle = styled("article")((param)=>{
    let { theme  } = param;
    return {
        width: "100%",
        display: "flex",
        flexDirection: "column",
        gap: theme.spacing(4)
    };
});
const BrandInfoBox = styled(Box)((param)=>{
    let { theme  } = param;
    return {
        display: "flex",
        gap: theme.spacing(1),
        justifyContent: "space-between",
        alignItems: "center",
        margin: 0
    };
});
const TooltipBubble = styled("p")((param)=>{
    let { theme  } = param;
    return {
        position: "absolute",
        display: "flex",
        top: "-14px",
        left: "12px",
        backgroundColor: theme.palette.text.title,
        color: theme.palette.blackAndWhite.white,
        zIndex: 1,
        borderRadius: "4px",
        padding: "4px 10px 4px 8px",
        "&::after": {
            content: '""',
            position: "absolute",
            // 말풍선이 버튼 위로 이동함에 따라 꼬리를 아래(버튼 방향)로 향하게 변경
            top: "100%",
            right: "10px",
            width: 0,
            height: 0,
            borderLeft: "4px solid transparent",
            borderRight: "4px solid transparent",
            borderTop: "6px solid ".concat(theme.palette.grey[700])
        }
    };
});
const MotionBox = motion(Box);
